import React, { ComponentProps } from 'react'
import PriceRowLuxPlusPrice from './PriceRowLuxPlusPrice'

type InheritedPriceRowLuxPlusPriceProps = Pick<ComponentProps<typeof PriceRowLuxPlusPrice>, 'className' | 'discountPercentage' | 'discountType' | 'memberPrice' | 'saleUnit' | 'signDisplay' | 'size'>

interface Props extends InheritedPriceRowLuxPlusPriceProps {
  caption: string
}

/**
 * Displays a formatted price with a leading caption and a trailing sale unit.
 */
function PriceRowLuxPlusPriceWithCaption(props: Props) {
  return <PriceRowLuxPlusPrice
    {...props}
    logoPlacement="leading"
  />
}

export default PriceRowLuxPlusPriceWithCaption
